"use client"

import React, { useState, useEffect } from "react"
import { useConvex } from "convex/react"
import { api } from "@/convex/_generated/api"
import { Loader2, ChevronDown } from "lucide-react"
import ShowcaseVideoCard from "./ShowcaseVideoCard"

export default function LoadMore({ initialCursor, filters }) {
	const convex = useConvex()
	const [cursor, setCursor] = useState(initialCursor)
	const [allVideos, setAllVideos] = useState([])
	const [isExhausted, setIsExhausted] = useState(false)
	const [isLoading, setIsLoading] = useState(false)

	// 当过滤器改变时，重置所有客户端加载的状态
	useEffect(() => {
		setCursor(initialCursor)
		setAllVideos([])
		setIsExhausted(false)
	}, [filters, initialCursor])

	const loadMoreVideos = async () => {
		if (isExhausted || isLoading || !cursor) return
		
		setIsLoading(true)
		
		try {
			const result = await convex.query(api.videoData.GetPublicVideosPaginated, {
				paginationOpts: { numItems: 6, cursor: cursor },
				filters: Object.keys(filters).length > 0 ? filters : undefined
			})

			setAllVideos(prev => [...prev, ...result.page])
			setCursor(result.continueCursor)
			if (result.isDone) setIsExhausted(true)
		} catch (error) {
			console.error("Error loading more videos:", error)
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<>
			{allVideos.length > 0 && (
				<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-10 mt-8 md:mt-10">
					{allVideos.map((video) => (
						<ShowcaseVideoCard key={video._id} video={video} />
					))}
				</div>
			)}

			{!isExhausted && cursor && (
				<div className="flex justify-center mt-20">
					<button
						onClick={loadMoreVideos}
						disabled={isLoading}
						className="btn btn-primary btn-lg rounded-full px-12 gap-3 shadow-xl shadow-primary/20 hover:scale-105 transition-all"
					>
						{isLoading ? (
							<Loader2 className="animate-spin w-5 h-5" />
						) : (
							<ChevronDown size={20} />
						)}
						{isLoading ? "Loading..." : "Load More"}
					</button>
				</div>
			)}

			{isExhausted && allVideos.length > 0 && (
				<div className="text-center mt-20 opacity-30 text-sm font-medium">
					You've reached the end of the showcase ✨
				</div>
			)}
		</>
	)
}
